export default "__VITE_ASSET__UBz7S5bU__"